export const eiTabsStyles = (theme) => ({
  tabSelected: {
    backgroundColor: theme.palette.grey[100],
  },
})
